import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthContext, AuthState } from '../../../contexts/authContext'
import { UserType } from '../../../contexts/authContext'

type PrivateRouteProps = {
  path: string
  userType?: UserType
  component: React.FC<any>
}

/**
 * Redirects the page to home if a private page is accessed
 * by an anonymous (not signed in) user
 */
const PrivateRoute: React.FC<PrivateRouteProps> = ({
  path,
  userType = UserType.migrant,
  component
}) => {
  const authContext = useContext(AuthContext)

  if (authContext?.authState === AuthState.signedOut) {
    // case: User is not logged in
    // action: redirect to migrant or vendor login page
    return (
      <Route
        exact
        path={path}
        render={({ location }) => (
          <Redirect
            to={{
              pathname:
                userType === UserType.migrant ? '/login' : '/vendor/login',
              state: { from: location }
            }}
          />
        )}
      />
    )
  } else if (
    authContext?.authState === AuthState.signedIn &&
    authContext?.userType !== userType
  ) {
    // case: User/migrant is logged in, but trying to access a page meant for vendor (or vice versa)
    // action: redirect to migrant or vendor dashboard
    return (
      <Route
        exact
        path={path}
        render={({ location }) => (
          <Redirect
            to={{
              pathname:
                authContext.userType === UserType.migrant ? '/' : '/vendor',
              state: { from: location }
            }}
          />
        )}
      />
    )
  } else {
    // case: All checks passed
    // action: display intended route component
    return <Route exact path={path} component={component} />
  }
}

export default PrivateRoute
